import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import svgBack from "../assets/SVGs/back.svg";
import { Worker } from "@react-pdf-viewer/core";
import { Viewer } from "@react-pdf-viewer/core";
import { toolbarPlugin, ToolbarSlot } from "@react-pdf-viewer/toolbar";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";
import { LocalizationContext } from "@react-pdf-viewer/core";

import vi_VN from "./en_US.json";

function PDFLayout() {
  const token = localStorage.getItem("token");
  const location = useLocation();
  const navigate = useNavigate();
  const [fileUrl, setFileUrl] = useState(null);
  const [showNavigation, setShowNavigation] = useState(false);
  const [loading, setLoading] = useState(true);
  const toolbarPluginInstance = toolbarPlugin();
  const { Toolbar } = toolbarPluginInstance;
  const [l10n, setL10n] = React.useState(vi_VN);
  const localizationContext = { l10n, setL10n };

  const renderToolbar = (Toolbar) => (
    <Toolbar>
      {(ToolbarSlot) => {
        const { EnterFullScreen, Zoom, ZoomIn, ZoomOut } = ToolbarSlot;
        return (
          <LocalizationContext.Provider value={localizationContext}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                padding: "0 10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <ZoomOut />
                <Zoom />
                <ZoomIn />
              </div>
              <EnterFullScreen />
            </div>
          </LocalizationContext.Provider>
        );
      }}
    </Toolbar>
  );

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar,
    sidebarTabs: () => [],
  });

  useEffect(() => {
    if (location.state?.Address) {
      setFileUrl(location.state.Address);
      setLoading(true);
    }
  }, [location.state]);

  let runonce = false;
  window.onpopstate = () => {
    if (!runonce) {
      navigate(-1);
      runonce = true;
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "90vh",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px",
          backgroundColor: "#162760",
        }}
      >
        {showNavigation && (
          <div style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
            <img
              src={svgBack}
              style={{ width: "33px", height: "33px" }}
              alt="Back"
            />
          </div>
        )}
      </div>
      <div
        style={{
          flex: 1,
          overflow: "auto",
        }}
      >
        {fileUrl ? (
          <Worker
            workerUrl={
              "pdf.worker.js"
            }
          >
            <Viewer
              fileUrl={fileUrl}
              httpHeaders={{ Authorization: `Bearer ${token}` }}
              plugins={[defaultLayoutPluginInstance]}
              error={<div>خطا در دریافت فایل Pdf</div>}
              loading={<div>در حال نمایش فایل Pdf ...</div>}
              onDocumentLoad={() => {
                setLoading(false);
                setShowNavigation(true);
              }}
            />
          </Worker>
        ) : (
          <div style={{ margin: "auto" }}></div>
        )}
      </div>
    </div>
  );
}

export default PDFLayout;
